import * as React from "react";
import AboutApp from "./AboutApp";
import { Button } from '@mui/material';
import { observer } from "mobx-react";
import { useStores } from "../../Stores/MainStore";
import Feedback from "../../Partial/Feedback/Feedback";
import { language } from "../../lang";

const Footer = observer(() => {

    const { ConfigStore } = useStores();

    const year = new Date().getFullYear();

    const [lng, setLng] = React.useState(ConfigStore.lang);

    const handleClickOpen = (scrollType) => () => {
        ConfigStore.setIsAboutShow(true);
        ConfigStore.setScroll(scrollType);
    };

    const openFeed = () => {
        ConfigStore.setIsFeedbackShow(true);
    };

    React.useEffect(() => {
        setLng(ConfigStore.lang);
    }, [ConfigStore.lang]);

    return(
        <footer>
            <Button onClick={handleClickOpen('paper')} className='footer__button'>
                {lng === "de" ? language.aboutApp.de : language.aboutApp.en}
            </Button>
            <p className="rights__bg">Source of image <a href="https://unsplash.com/photos/MEUvVqkU3QI">here</a></p>
            <div className="footer__rights">
                All rights reserved © {year}
            </div>
            <AboutApp />
            <Feedback />
            <Button onClick={openFeed} className='footer__button'>
                {lng === "de" ? language.feedback.de : language.feedback.en}
            </Button>
        </footer>
    );
});

export default Footer;